module.exports = __webpack_public_path__ + "img/mapbox-600x600.bbb8e292.bbb8e292.png";